export default __webpack_public_path__ + "static/media/link.64cd2367.svg";